import { render, staticRenderFns } from "./newsfq.vue?vue&type=template&id=300d5b03&scoped=true&"
import script from "./newsfq.vue?vue&type=script&lang=js&"
export * from "./newsfq.vue?vue&type=script&lang=js&"
import style0 from "./newsfq.vue?vue&type=style&index=0&id=300d5b03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300d5b03",
  null
  
)

export default component.exports